import Message from "../../../../i18n/Message";
import TrashIcon from "../../../../assets/icons/TrashIcon";
import FolderIcon from "../../../../assets/icons/FolderIcon";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { deleteKBase } from "../store/kbaseActionCreators";
import { useIntl } from "react-intl";
import dayjs from "dayjs";

import "./KBaseTile.scss";
import { useParams } from "react-router-dom";
import { BookIcon } from "lucide-react";
import { linkToKnowledgeBase } from "../../../../routes";

const KBaseTile = ({ kbase }) => {
  const { workspaceId } = useParams();
  const nav = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const onDeleteConfirmed = () => {
    const onSuccess = () => {
      setShowDeleteConfirm(false);
    };
    const onError = () => {
      setShowDeleteConfirm(false);
    };
    dispatch(deleteKBase(intl, workspaceId, kbase.uid, onSuccess, onError));
  };

  return (
    <div className="campaign_tile card kbase_tile border-radius-lg d-flex">
      <div
        className="d-flex flex-column tile_body"
        onClick={() => nav(linkToKnowledgeBase(workspaceId, kbase.uid))}
      >
        <div className="tile-name">
          <BookIcon size="20" color="#344767" />
          <span>{kbase.name}</span>
        </div>
        <div className="metadata_row">
          <div className="meta_name">
            <Message id="created_on" />
          </div>
          <div className="meta_value">
            {dayjs(kbase.dateCreated).format("LLL")}
          </div>
        </div>
      </div>
      <div className="d-flex tile-actions">
        <div className="confirm_container">
          {showDeleteConfirm && (
            <>
              <div
                className="cover"
                onClick={() => setShowDeleteConfirm(false)}
              ></div>
              <div className="confirm_panel">
                <button
                  className="btn bg-gradient-primary btn-sm"
                  onClick={onDeleteConfirmed}
                >
                  <Message id="confirm_delete" />
                </button>
              </div>
            </>
          )}
        </div>
        <button
          className="no-btn tile-action"
          onClick={() => setShowDeleteConfirm(true)}
        >
          <TrashIcon size="16" color="#344767" />
          <Message id="delete" />
        </button>
      </div>
    </div>
  );
};

export default KBaseTile;
